/**
 * Mocking client-server processing
 */
import { store } from "../main";
import {
  toggleLoginModal,
  storeFailedAPIcalls,
  toggleModal,
  storeError,
  loginLoading
} from "../store/common";
import { loadingProducts } from "../store/product";

// ? "http://localhost:8099/api/oz/"
// const devEnv = "https://admin.mobilnet.sk/api/oz/";
// const devEnv = "https://admin-dev.mobilnet.sk/api/oz/";
const devEnv = "https://administracia.mobilnet.sk/api/oz/";
const BASE_URL = __DEV__
  ? devEnv
  : `${window.env.baseURI}/${window.env.apiPath}/`;

const TIMEOUT = 500;
let abortController = new AbortController();
let signal = abortController.signal;

const generteNewAbortCtrl = () => {
  abortController = new AbortController();
  signal = abortController.signal;
};

generteNewAbortCtrl();

export const abortFetching = () => {
  // Abort.
  abortController.abort();
};

export const callApiWithAbortation = (url, body, method = "POST") => {
  generteNewAbortCtrl();

  const localToken = localStorage.getItem("token");
  return fetch(url, {
    method: method,
    signal: signal,
    headers: {
      Authorization: "Bearer " + (localToken || store.getState().common.token)
    },
    body: JSON.stringify(body)
  })
    .then(response => {
      if (response.status >= 200 && response.status < 300) {
        return response.json();
      } else if (response.status === 401) {
        return Promise.reject({ unauthorized: true });
      } else {
        return response.text().then(res => Promise.reject(res));
      }
    })
    .then(
      result => {
        return result;
      },
      error => {
        if (error.unauthorized) {
          store.dispatch(storeFailedAPIcalls(url, body, method));
          // store.dispatch(toggleLoginModal(true));
          store.dispatch(toggleModal("error_modal", true));
        } else if (error.name === "AbortError") {
          store.dispatch(loadingProducts(true));
        } else console.error(error);
      }
    );
};

export const callApi = (url, body, method = "POST") => {
  const localToken = localStorage.getItem("token");
  const token = localToken || store.getState().common.token;
  return fetch(url, {
    method: method,
    headers: {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  })
    .then(response => {
      if (response.status >= 200 && response.status < 300) {
        return response.json();
      } else if (response.status === 401) {
        // return Promise.reject({ unauthorized: true });
        return response
          .json()
          .then(res => Promise.reject({ ...res, unauthorized: true }));
      } else {
        return response.text().then(res => Promise.reject(res));
      }
    })
    .then(
      result => {
        return result;
      },
      error => {
        if (error.unauthorized) {
          store.dispatch(storeFailedAPIcalls(url, body, method));
          // store.dispatch(toggleLoginModal(true));
          store.dispatch(storeError(error));
          store.dispatch(toggleModal("error_modal", true));
          store.dispatch(loginLoading(false));
        } else {
          console.error(error);
          if (error && error.trim().length > 0) {
            store.dispatch(storeError(error));
            store.dispatch(toggleModal("error_modal", true));
            store.dispatch(loginLoading(false));
          }
        }
      }
    );
};

export default {
  getSalesmen: (cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "salesmen", undefined, "GET"));
    }, timeout || TIMEOUT),
  getCustomers: (oz, cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + +oz + "/customers", undefined, "GET"));
    }, timeout || TIMEOUT),
  getCategories: (cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "categories", undefined, "GET"));
    }, timeout || TIMEOUT),
  getMEC: (cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "mec", undefined, "GET"));
    }, timeout || TIMEOUT),
  getAltProducts: (category, brand, model, user, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApiWithAbortation(
          BASE_URL + "products/user/" + user + "/alternative",
          {
            category: category,
            brand: brand,
            model: model
          }
        )
      );
    }, timeout || TIMEOUT),
  getProducts: (
    category,
    offset,
    limit,
    filter,
    sortBy,
    sortOrder,
    user,
    type,
    cb,
    timeout
  ) =>
    setTimeout(() => {
      return cb(
        callApiWithAbortation(
          BASE_URL + "products/user/" + user + "/category/" + (category || 77),
          {
            offset: offset,
            limit: limit,
            filter: JSON.stringify(filter),
            sortBy: sortBy,
            sortOrder: sortOrder,
            type: type
          }
        )
      );
    }, timeout || TIMEOUT),
  getNewsProducts: (
    offset,
    limit,
    filter,
    sortBy,
    sortOrder,
    user,
    type,
    cb,
    timeout
  ) =>
    setTimeout(() => {
      // products/user/{user}/category/special/news
      return cb(
        callApiWithAbortation(
          BASE_URL + "products/user/" + user + "/category/special/news",
          {
            offset: offset,
            limit: limit,
            filter: JSON.stringify(filter),
            sortBy: sortBy,
            sortOrder: sortOrder,
            type: type
          }
        )
      );
    }, timeout || TIMEOUT),
  getCartItems: (customerId, orderType, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(BASE_URL + "cart", {
          customer_id: customerId,
          order_type: orderType
        })
      );
    }, timeout || TIMEOUT),
  getSummaryItems: (customerId, orderType, langId = 1, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(BASE_URL + "summary", {
          customer_id: customerId,
          order_type: orderType,
          language_id: langId
        })
      );
    }, timeout || TIMEOUT),
  hasCustomerCartItems: (customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(BASE_URL + "customer/" + customerId + "/cart/available")
      );
    }, timeout || TIMEOUT),
  getImportedItems: (importedList, customerId, orderType, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          BASE_URL +
          "customer/" +
          customerId +
          "/cart/" +
          orderType +
          "/imported/items",
          {
            list: importedList
          }
        )
      );
    }, timeout || TIMEOUT),
  importCartItems: (customerId, orderType, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          BASE_URL + "customer/" + customerId + "/cart/" + orderType + "/import"
        )
      );
    }, timeout || TIMEOUT),
  getCustomerCartItems: (customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(BASE_URL + "customer/" + customerId + "/cart", undefined, "GET")
      );
    }, timeout || TIMEOUT),
  addCartItem: (cartItemData, cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "cart/add", cartItemData));
    }, timeout || TIMEOUT),
  removeCartItem: (product, customer, orderType, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          BASE_URL +
          "customer/" +
          customer +
          "/cart/" +
          orderType +
          "/delete/" +
          product,
          undefined,
          "DELETE"
        )
      );
    }, timeout || TIMEOUT),
  removeCart: (customer, orderType, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          BASE_URL +
          "customer/" +
          customer +
          "/cart/" +
          orderType +
          "/truncate",
          undefined,
          "DELETE"
        )
      );
    }, timeout || TIMEOUT),
  setCartNote: (note, customerId, orderType, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(BASE_URL + "cart/note", {
          note: note,
          customer_id: customerId,
          order_type: orderType
        })
      );
    }, timeout || TIMEOUT),
  getCartNote: (customerId, orderType, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          BASE_URL + "cart/" + orderType + "/customer/" + customerId + "/note",
          undefined,
          "GET"
        )
      );
    }, timeout || TIMEOUT),
  importSpecialCart: (customerId, data, cb, timeout) =>
    setTimeout(() => {
      console.log(`customerId: ${customerId}`);
      console.log('data')
      console.log(data);
      return cb(
        callApi(
          BASE_URL + "special/cart/import/items",
          {
            customer_id: customerId,
            list: data
          }
        )
      );
    }, timeout || TIMEOUT),

  forgottenPassword: (loginObj, cb, timeout) =>
    setTimeout(
      () => cb(callApi(`${BASE_URL}auth/forgotten/password`, loginObj)),
      timeout || TIMEOUT,
    ),
  getCommon: (credentials, cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "auth/login", credentials));
    }, timeout || TIMEOUT),
  getMeCommon: (cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "auth/me", undefined, "GET"));
    }, timeout || TIMEOUT),
  getOzMe: (oz, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(BASE_URL + "auth/salesman/" + oz + "/data", undefined, "GET")
      );
    }, timeout || TIMEOUT),
  searchProducts: (term, type, customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          BASE_URL + "product/search",
          {
            term: term,
            type: type,
            customer_id: customerId
          },
          "POST"
        )
      );
    }, timeout || TIMEOUT),
  searchCompatibility: (term, cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "compatibility", { term: term }, "POST"));
    }, timeout || TIMEOUT),
  getCountries: (cb, timeout) =>
    setTimeout(
      () => cb(callApi(BASE_URL + "countries", undefined, "GET")),
      timeout || TIMEOUT
    ),
  getOrders: (cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "orders", undefined, "GET"));
    }, timeout || TIMEOUT),
  createOrder: (orderData, cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "order/create", orderData));
    }, timeout || TIMEOUT),
  getOrderPDF: (id, cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "order/pdf/" + id, undefined, "GET"));
    }, timeout || TIMEOUT),
  getOrder_detail: (order, cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "order/" + order, undefined, "GET"));
    }, timeout || TIMEOUT),
  submitOpenedOrder: (customerId, data, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          BASE_URL + "orders/" + customerId + "/opened/submit",
          data,
          "POST"
        )
      );
    }, timeout || TIMEOUT),
  getSummaryOpenedOrder: (customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          BASE_URL + "orders/" + customerId + "/opened/summary",
          undefined,
          "GET"
        )
      );
    }, timeout || TIMEOUT),
  getSales: (cb, timeout) =>
    setTimeout(() => {
      return cb(callApi(BASE_URL + "sales", undefined, "GET"));
    }, timeout || TIMEOUT),
  getHots: (customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          BASE_URL + "products/user/" + customerId + "/hot",
          undefined,
          "GET"
        )
      );
    }, timeout || TIMEOUT),
  setOzUserNote: (note, customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(`${BASE_URL}user/note`, {
          note: note,
          customer_id: customerId,
        })
      );
    }, timeout || TIMEOUT),
  getCommonTopSellingProducts: (customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          `${BASE_URL}products/top/${customerId}/selling`,
          undefined,
          "GET"
        )
      );
    }, timeout || TIMEOUT),
  getUserTopSellingProducts: (customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(
          `${BASE_URL}products/user/${customerId}/selling`,
          undefined,
          "GET"
        )
      );
    }, timeout || TIMEOUT),
  getMockImages: (cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(`https://jsonplaceholder.typicode.com/photos`, undefined, 'GET')
      );
    }, timeout || TIMEOUT),
  getofficeImages: (customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(`${BASE_URL}client/${customerId}/office/photos`, undefined, 'GET')
      );
    }, timeout || TIMEOUT),
  getLastCustomerOrder: (customerId, cb, timeout) =>
    setTimeout(() => {
      return cb(
        callApi(`${BASE_URL}orders/${customerId}/last`, undefined, 'GET')
      );
    }, timeout || TIMEOUT),

};



// WEBPACK FOOTER //
// ./src/api/shop.js